window.lockMove = false;

var MapView = ViewModel.extend({
    defaults: {
        isInit: false,
        map: {},
        search: {},
        config: {},
        searchCenter: null
    },

    initialize: function (options) {
        MapView.__super__.initialize.apply(this, arguments);
        this.options = options;
    },


    /**
     * Render use the compiled template to change the source of the target DOM node.
     * children classes will define what "this.template" will be!
     *
     * safeData() fetch data from model and send it to the template in a safe way. read on!
     */
    render: function () {
        var Markers = [];
        var me = this;

        //erstelle die Adressenergebnisse
        var AddressItems = this.model.get('AddressItems');

        _.each(AddressItems, function (Poi, i) {

            var MarkerSignals = me.CreatePoi(me.options.map, Poi, i);

            Markers.push(MarkerSignals.marker);

            if (me.options.isInit) {
                if (i == AddressItems.length - 1) {
                    me._PoisCreated(Markers, me.options.search, me.options.config);
                }
            }
        });

        //erstelle die Shadow-Adressenergebnisse
        var AddressShadowItems = this.model.get('AddressShadowItems');

        _.each(AddressShadowItems, function (Poi, i) {

            var MarkerSignals = me.CreateShadowPoi(me.options.map, Poi, i);

            Markers.push(MarkerSignals.marker);

            if (me.options.isInit) {
                if (i == AddressItems.length - 1) {
                    me._PoisCreated(Markers, me.options.search, me.options.config);
                }
            }
        });

        //erstelle die Cluster-Adressenergebnisse
        var AddressClusterItems = this.model.get('AddressTiles');

        _.each(AddressClusterItems, function (Poi, i) {

            var MarkerSignals = me.CreateClusterPoi(me.options.map, Poi, i, me.options.config);

            Markers.push(MarkerSignals.marker);

            if (me.options.isInit) {
                if (i == AddressItems.length - 1) {
                    me._PoisCreated(Markers, me.options.search, me.options.config);
                }
            }
        });

        return this;
    },

    CreatePoi: function (map, Poi, i) {
        var GeoPoint = new ym.geo.CGeoPoint(Poi.BasicData.Geo.YCoord, Poi.BasicData.Geo.XCoord);

        var MarkerSignals = new CMarkerSignals({
            Icon: Poi.GeneratedData.Icon,
            Position: GeoPoint,
            LayerID: "FilialLayer",
            OrdinalNumber: i,
            OriginalPoi: Poi,
            ZIndex: 5000
        }, signals);

        var popupModel = new Backbone.Model(Poi);
        var popupTmpl = new PopupView({model: popupModel});
        popupTmpl.render();

        MarkerSignals.marker.setInfoBoxOptions({
            Position: ym.map.INFO_BOX_POSITION.AUTO,
            ShowOnHover: true,
            ContentTemplate: popupTmpl.$el.children()[0]
        });

        $('.resultlist > li:eq(' + i + ')').hover(
            function (e) {
                MarkerSignals.marker.showInfoBox();
            },
            function (e) {
                MarkerSignals.marker.hideInfoBox();
            });

        map.addMarker(MarkerSignals.marker);
        map.showMarker(MarkerSignals.marker);

        return MarkerSignals;
    },

    CreateShadowPoi: function (map, Poi, i) {
        var GeoPoint = new ym.geo.CGeoPoint(Poi.BasicData.Geo.YCoord, Poi.BasicData.Geo.XCoord);

        var MarkerSignals = new CMarkerSignals({
            Icon: Poi.GeneratedData.Icon,
            Position: GeoPoint,
            LayerID: "FilialLayer",
            OrdinalNumber: i,
            OriginalPoi: Poi,
            ZIndex: 5000
        }, signals);

        map.addMarker(MarkerSignals.marker);
        map.showMarker(MarkerSignals.marker);

        return MarkerSignals;
    },

    CreateClusterPoi: function (map, Poi, i, config) {
        var me = this;
        var GeoPoint = new ym.geo.CGeoPoint(Poi.YFocus, Poi.XFocus);

        Poi.BranchCodes = me.options.config.BranchCodes;
        Poi.ClusterLevel = map.getZoomLevel() + config.ClusterLevelOffset;
        var MarkerSignals = new CMarkerSignals({
            Icon: Poi.GeneratedData.Icon,
            Position: GeoPoint,
            LayerID: "FilialLayer",
            OrdinalNumber: i,
            OriginalPoi: Poi,
            ZIndex: 5000

        }, signals);


        MarkerSignals.marker.target = me;

        MarkerSignals.marker.addListener("onmouseover", me.searchClusterDetails);

        MarkerSignals.marker.addListener("onmouseout", function () {
            this.hideInfoBox();
        });

        map.addMarker(MarkerSignals.marker);
        map.showMarker(MarkerSignals.marker);

        return MarkerSignals;
    },

    searchClusterDetails: function (event) {
        var ymsearch = new ym.geo.CSearch();
        ///**function*/Callback, /**string*/Branchcodes, /**int*/ClusterID, /**int*/ClusterLevel, /**string*/ProductTypes, /**OPTIONAL object*/AdditionalParams
        var target = this.target;
        var poi = this.OriginalPoi;
        var marker = this;
        ymsearch.lookupCluster(function (data) {
            target.onClusterDetailsResult(marker, target, poi, data);
        }, this.OriginalPoi.BranchCodes, this.OriginalPoi.ClusterID, this.OriginalPoi.ClusterLevel, this.OriginalPoi.ProductTypes);
    },

    onClusterDetailsResult: function (marker, me, poi, data) {

        var resultListModel = new ResultListModel();
        resultListModel.set('TitlePrefix', "H2-Tankstellen");
        resultListModel.fromJSON(data);

        var popupModel = new ClusterPopupModel();
        popupModel.fromResultList(poi, resultListModel);

        var popupTmpl = new ViewClusterPopup({model: popupModel});
        popupTmpl.render();

        marker.setInfoBoxOptions({
            Position: ym.map.INFO_BOX_POSITION.AUTO,
            ShowOnHover: false,
            ContentTemplate: popupTmpl.$el.children()[0]
        });

        marker.showInfoBox();
    },

    _PoisCreated: function (Markers, search, config) {
        this.options.map.optimizeMapForResult(Markers);
        var self = this;

        // setTimeout(function () {
        //     signals.on('mapendmove', function (map, event) {
        //         if (!lockMove) {
        //             var zoomlevel = map.getZoomLevel();
        //
        //             if (zoomlevel <= 13) {
        //                 searchSignals.searchInAreaByBranchCode(config.BranchCodes, {
        //                     ZoomLevel: map.getZoomLevel(),
        //                     ClusterLevel: map.getZoomLevel() + config.ClusterLevelOffset
        //                 });
        //             }
        //             else {
        //                 var addition = 'Database=YM_FILIALEN';
        //                 if (self.options.searchCenter) {
        //                     addition += '&LocXForDistanceCalculation=' + self.options.searchCenter.Position.Longitude +
        //                         '&LocYForDistanceCalculation=' + self.options.searchCenter.Position.Latitude
        //                 }
        //                 searchSignals.searchInAreaByBranchCode(config.BranchCodes, {
        //                     Addition: encodeURIComponent(addition),
        //                     ZoomLevel: map.getZoomLevel(),
        //                     Top: self.options.config.Top
        //                 });
        //             }
        //         } else {
        //             setTimeout(function () {
        //                 lockMove = false;
        //             }, 1000);
        //         }
        //     });
        // }, 1000);
    }
});